import { isMatchPreviewPath } from "./match/routes";

export type BootRoute = "daily" | "match-preview";

export function bootRouteForPath(pathname: string, dev: boolean): BootRoute {
  if (!dev && isMatchPreviewPath(pathname)) return "match-preview";
  return "daily";
}
